import { Component, OnInit,EventEmitter, Output } from '@angular/core';
import { DataBridgeService } from '../../../services/data-bridge.service';
import * as d3 from 'd3';
import { Input } from '@angular/core';

@Component({
  selector: 'lib-interactions-injection',
  templateUrl: './interactions-injection.component.html',
  styleUrls: ['./interactions-injection.component.css']
})


export class InteractionsInjectionComponent implements OnInit {
  @Input() mouseEvent: any;
  @Input() svgComponent: any;
  @Input() data: any;
  @Input() floorType: any;
  @Input() floorDetails: any;
  @Input() seatID: string;
  @Output() finishedInteractionsInjection: EventEmitter<any>= new EventEmitter<any>();

  viewType: string = 'mobile'
  seatFeatureData: any={};
  constructor(private _dataBridge: DataBridgeService){

  };
  ngOnInit(){
    let viewType = this.getQueryStringValue('openedFrom')
    this.viewType = (viewType && viewType.length > 0 && viewType === 'web')? 'web': 'mobile'
    this._dataBridge.setAspectRatio(this.data.features[0].geometry.coordinates[0][2]);
        this._dataBridge.calculateClientToMapRatio();
        let dataToTransmit = null;
        let assignmentPromises = [];
        this.prepareData();
        let groups = this.svgComponent.nativeElement?d3.select(this.svgComponent.nativeElement).selectAll("g"):d3.select(this.svgComponent).selectAll("g");
        // ADD SEATS AMD ROOMS
        let that = this;
        let baseGroups = groups['_groups'][0];
        if(baseGroups){
        baseGroups.forEach(element => {
            if (element.getAttribute('type') == "SEAT") {
                let p = new Promise((resolve, reject) => {
                    let d = this.seatFeatureData[element.getAttribute('seatId')];
                    let properties = d['properties'];
                    let seat = d3.select(document.getElementById(properties['ID'] + 'SEAT'));
                    let currentImageName = seat.attr('imageName');
                    let width = seat.attr('width');
                    let height = seat.attr('height');
                    let xPos = seat.attr('x');
                    let yPos = seat.attr('y');
                    if(this.viewType === 'web'){
                        d3.select(element)
                            .on("mouseover", (event) => {
                                that.mouseEvent.emit({ additionalData: { displayText: d.properties.name,data:d }, event: event });
                            })
                            .on("mouseout", (event) => {
                                that.mouseEvent.emit({ additionalData: {}, event: event });
                            })
                    }
                    d3.select(element)
                        .on("click", (event, i) => {
                        that.mouseEvent.emit({ additionalData: { ID: properties['ID'], d, base: element, currentImageName, width, height, xPos, yPos }, event: event });
                    });
                    if(currentImageName){
                        if (properties['ID'] != this.seatID && currentImageName.includes('Selected')) {
                            currentImageName = currentImageName.substring(0, currentImageName.indexOf('Selected'));
                            d3.xml(`${that._dataBridge.getAssetsLocation()}/${currentImageName}.svg`)
                                .then((data) => {
                                d3.select(document.getElementById(properties['ID'] + "SEAT")).remove();
                                d3.select(element).append(() => {
                                    d3.select(data.documentElement)
                                        .attr("imageName", currentImageName)
                                        .attr("width", width)
                                        .attr("height", height)
                                        .attr("id", properties['ID'] + "SEAT")
                                        .attr("x", xPos)
                                        .attr("y", yPos)
                                        .attr("status", properties.status);
                                    return data.documentElement;
                                });
                            }).then(() => {
                                resolve(true);
                            }).catch(()=>{
                                reject(true);
                            });
                        }
                        else if (properties['ID'] == this.seatID && currentImageName.includes('Selected')) {
                            dataToTransmit = Object.assign(Object.assign({}, dataToTransmit), { selectedSeat: { ID: properties['ID'], details: d, base: element, currentImageName, width, height, xPos, yPos } });
                            resolve(true);
                        }
                        else {
                            resolve(true);
                        }
                    }
                    else{
                        resolve(true)
                    }
                    
                });
                assignmentPromises.push(p);
            }
        });
        }
        Promise.all(assignmentPromises).then(() => {
            this.finishedInteractionsInjection.emit(dataToTransmit);
            // if (this.data.image) {
            //   assignmentPromises.push(
            //     this.placeFloorImage().then((imageBase64) => {
            //       dataToTransmit = {
            //         ...dataToTransmit,
            //         imageBase64
            //       }
            //       this._dataBridge.setAspectRatio(this.data.features[0].geometry.coordinates[0][2]);
            //       this._dataBridge.calculateClientToMapRatio();
            //     })
            //   )
            // }
        })
    };
    prepareData() {
          this.data.features.forEach(element => {
              this.seatFeatureData[element.properties.ID] = element;
          });
    }
    placeFloorImage() {
      let promise = new Promise((resolve, reject) => {
          try {
              let image = this.data.image;
              const reader = new FileReader();
              reader.readAsDataURL(image);
              reader.onloadend = () => {
                  let floorBoundaryPath = document.getElementById(this.floorDetails.floorId);
                  let floorBoundaryGroup = floorBoundaryPath === null || floorBoundaryPath === void 0 ? void 0 : floorBoundaryPath.parentElement;
                  let image = d3.select(floorBoundaryGroup).append("image")
                      .attr("href", reader?.result?.toString())
                      .attr("id", this.floorDetails.floorId)
                      .style("width", (d, i) => {
                      return d3.select(this.svgComponent).attr("width");
                  })
                      .style("height", (d, i) => {
                      return d3.select(this.svgComponent).attr("height");
                  })
                      .style("opacity", "0")
                      .transition().duration(1500)
                      .style("opacity", '1');
                  resolve(reader?.result?.toString());
              };
          }
          catch (Exception) {
              reject(Exception);
          }
      });
      return promise;
    }
    public getQueryStringValue(key) {
        let value = "";
        if (window.location.href) {
          const queryStringPairs = window.location.href.split('?')[1] && window.location.href.split('?')[1].split('&');
          if (queryStringPairs) {
            for (let i = 0; i < queryStringPairs.length; i++) {
              const pair = queryStringPairs[i].split('=');
              if (pair[0] === key) {
                value = pair[1];
                break;
              }
            }
          }
          return value;
        }
        return '';
      }
}
